import styled from 'styled-components';

export const TableContainer = styled.div`

  .MuiTableCell-paddingNone{
    min-width:48px;
    max-width:99%;
  } //used to show checkbox and disable unnecessary scroll

  table{
    max-width: 98%;
  }
`;